import React from 'react'
import { TrackedCTA } from '../CallToAction'
import { Link } from 'gatsby'
import { heading, section } from './classes'
import Icon from './Icon'
import { PricingCTA } from 'components/PricingCTA'
import { SignupCTA } from 'components/SignupCTA'
import { Demo } from 'components/NotProductIcons'
import {prepareData} from 'utils/googleData'


export default function Hero(props) {
   const {enable,title,subtitle,description,cta,direction,style,gatsbyImage,features,gatsbyImage2}= prepareData({props})
     if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
    return (
        <>
            <h1 className={heading()}
                dangerouslySetInnerHTML={{ __html: title }}>
            </h1>
            <h2 className={heading('subtitle', 'primary', 'my-6')}>
                {subtitle}
            </h2>
        </>
    )
}

export function DemoCTA(props) {
    const {enable,dark = false, text='Get a demo',type='custom',width,url='/book-a-meeting',event,subtitle,description,cta,direction,style: className = '',gatsbyImage,features,gatsbyImage2}= prepareData({props})
        if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
    return (
        <div  direction={direction} className="justify-center mt-6 flex">
            <TrackedCTA
             direction={direction}
                event={{ name: `clicked Get a demo` }}
                type={type}
                className={`bg-accent dark:bg-light shadow-none !text-sm !font-bold flex items-center  hover:text-blue space-x-1 !px-3 !py-2 hover:bg-gray-accent-light dark:hover:bg-gray-accent-light  rounded`}
                href={url}
            >
                <span  direction={direction} className="inline-block w-6 h-6 opacity-30 group-hover:opacity-50">
                    <Demo />
                </span>
                <span>{text}</span>
            </TrackedCTA>
        </div>
    )
}
